export type LaunchRecording = {
  recording_page_url: string | null;
  recording_video_url: string | null;
  recording_duration_seconds: number | null;
  recording_duration_is_estimated: boolean;
  recording_duration_source: string | null;
  recording_saved_at: string | null;
};

export type LaunchEventSnapshot = {
  id: string;
  event_name: string;
  event_date: string;
  observed_on: string;
  source_label: string;
  current_subscribers: number;
  subscribed_this_month: number;
  unsubscribed_this_month: number;
  current_members: number;
  former_members: number;
  viewers: number;
  non_members: number;
  escape_overlap: number;
  daily_captured_at: string;
  daily_counts: { date: string; count: number }[];
  unknown_signup_date_count: number;
};

export type LaunchDailyRow = {
  day: string | null;
  signup_count: number;
  paid_count: number;
  unknown_order_count: number;
  estimated_date_count?: number;
  order_incl: number | null;
  order_excl: number | null;
  paid_incl: number | null;
  paid_excl: number | null;
};
export type LaunchDailyReport = { mode: "website" | "historical"; daily: LaunchDailyRow[] };

// Use calendar dates, independent of the device timezone. Include quiet days.
export function snapshotDayRows(snapshot: Pick<LaunchEventSnapshot, "daily_counts" | "observed_on">) {
  const counts = new Map(snapshot.daily_counts.map(row => [row.date, row.count]));
  const start = [...counts.keys()].sort()[0];
  if (!start) return [];
  const rows: { date: string; count: number; cumulative: number }[] = [];
  let cumulative = 0;
  for (let day = start; day <= snapshot.observed_on;) {
    const count = counts.get(day) || 0;
    cumulative += count;
    rows.push({ date: day, count, cumulative });
    day = new Date(Date.parse(`${day}T12:00:00Z`) + 86400000).toISOString().slice(0, 10);
  }
  return rows;
}

export function snapshotCsv(snapshot: LaunchEventSnapshot) {
  const rows: (string | number)[][] = [
    ["Event", snapshot.event_name], ["Eventdatum", snapshot.event_date],
    ["Vaste momentopname", snapshot.observed_on], ["Bron", snapshot.source_label],
    ["Daggegevens opgehaald", snapshot.daily_captured_at],
    ["Actieve eventadressen", snapshot.current_subscribers],
    ["Nieuw deze maand", snapshot.subscribed_this_month], ["Opgezegd deze maand", snapshot.unsubscribed_this_month],
    ["Nettogroei deze maand", snapshot.subscribed_this_month - snapshot.unsubscribed_this_month],
    ["Huidige leden", snapshot.current_members], ["Voormalige leden", snapshot.former_members],
    ["Meekijkers", snapshot.viewers], ["Niet-leden (exclusief voormalige leden)", snapshot.non_members],
    ["Ook op Escape 925", snapshot.escape_overlap],
    ["Niet op Escape 925", snapshot.current_subscribers - snapshot.escape_overlap], [],
    ["Inschrijfdatum", "Actieve eventadressen op momentopname", "Cumulatief"],
    ...snapshotDayRows(snapshot).map(row => [row.date, row.count, row.cumulative]),
    ["Datum onbekend", snapshot.unknown_signup_date_count],
  ];
  return "\uFEFF" + rows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(";")).join("\r\n");
}
